import { BuyerRelationshipListResponseType } from "@sellar-io/api-v2/types";
import { Button } from "@sellar-io/components";
import { useState } from "react";
import { usePushNotificationDevicesList } from "../../hooks/api/v2/pushNotification/usePushNotificationDevicesList";
import { useRemoteFeatureFlags } from "../../hooks/useRemoteFeatureFlags";
import { FavouriteNotificationSettingsTable } from "../../pages/settings/notificationSettings/FavouriteNotificationSettingsTable";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../modal/Dialog";
import { EnablePushNotificationAlert } from "../pushNotification/EnablePushNotificationAlert";
import { getIsPushNotificationsDisabled } from "../pushNotification/PushNotificationStore";
import { AddToFavouritesButton } from "./AddToFavouritesButton";
import { RemoveFromFavouritesButton } from "./RemoveFromFavouritesButton";

export const AddToFavouritesGroup = ({
  buyerRelationship,
}: {
  buyerRelationship: BuyerRelationshipListResponseType[number] | undefined;
}) => {
  const { isActive } = useRemoteFeatureFlags();
  const [dialogActive, setDialogActive] = useState(false);
  const addToFavouritesActive = isActive("inAppNotifications");
  const [addedToFavourites, setAddedToFavourites] = useState(
    !!buyerRelationship?.BuyerRelationshipFavourite,
  );
  if (!addToFavouritesActive) return null;
  if (!buyerRelationship?.id) return null;
  return (
    <>
      {buyerRelationship.BuyerRelationshipFavourite?.id || addedToFavourites ? (
        <RemoveFromFavouritesButton
          buyerRelationshipFavouriteId={
            buyerRelationship.BuyerRelationshipFavourite?.id
          }
          setAddedToFavourites={setAddedToFavourites}
        />
      ) : (
        <AddToFavouritesButton
          buyerRelationshipId={buyerRelationship.id}
          setAddedToFavourites={setAddedToFavourites}
          setDialogActive={setDialogActive}
        />
      )}

      <FirstFavouriteDialog
        supplierName={buyerRelationship.Relationship.Supplier.Business.name}
        active={dialogActive}
        onDismiss={() => setDialogActive(false)}
      />
    </>
  );
};

const FirstFavouriteDialog = ({
  active,
  onDismiss,
  supplierName,
}: {
  active: boolean;
  onDismiss: () => void;
  supplierName: string;
}) => {
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={`${supplierName} favourited`}
        description={`You will get notified when they release new products without having to check yourself. This won't affect how often ${supplierName} reaches out to you.`}
      />
      <DialogContent className={"flex flex-col gap-4"}>
        <FirstFavouriteDialogContent />
      </DialogContent>
      <DialogCTA>
        <Button onClick={onDismiss}>Confirm</Button>
      </DialogCTA>
    </Dialog>
  );
};

const FirstFavouriteDialogContent = () => {
  const pushNotificationDevicesQuery = usePushNotificationDevicesList({});
  const { pushNotificationsDisabled, deviceDisabled } =
    getIsPushNotificationsDisabled({ pushNotificationDevicesQuery });
  return (
    <>
      <EnablePushNotificationAlert
        title="Enable push notifications on this device?"
        message="You need to turn on notifications for this current device to edit your push notification preferences."
        className="mb-4 w-full"
        deviceDisabled={deviceDisabled}
      />
      <FavouriteNotificationSettingsTable
        pushNotificationsDisabled={pushNotificationsDisabled}
      />
    </>
  );
};
